























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import CustomSelect from '@/common/CustomSelect.vue';
import { AvailableDeliverySlotDto, CustomersApi } from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import SelectItem from '@/common/SelectItem';
import { DefaultOrderDetailService } from '@/services/order/DefaultOrderDetailService';

@Component({
  components: {CustomSelect}
})
export default class DeliveryStepView extends Vue {
  @Prop({required: false, default: 'de'})
  public locale: string;

  public slots: AvailableDeliverySlotDto[] = [];
  public deliverySlots: SelectItem[] = [];
  public slotIndex = 0;

  private defaultOrderDetailService = DefaultOrderDetailService.singleton();

  public mounted() {
    const api = ApiService.wrap(CustomersApi);
    api.getEffectiveCustomerDeliverySlots(ConfigService.getTenant(), ConfigService.currentCustomerId).then((result) => {
      this.slots = result;
      for (const slot of this.slots) {
        const options = {
          weekday: 'long',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        const slotDate = new Date(slot.day).toLocaleDateString(this.locale, options);
        if (slot.time !== '') {
          this.deliverySlots.push(new SelectItem(slotDate + ' - ' + slot.time));
        } else {
          this.deliverySlots.push(new SelectItem(slotDate));
        }
      }
    }).catch(ApiService.defaultErrorHandler);
  }

  @Watch('currentDeliverySlot')
  public onSlotChange() {
    this.defaultOrderDetailService.saveDeliverySlot(this.slots[this.slotIndex]);
  }

  get currentDeliverySlot() {
    return this.deliverySlots[this.slotIndex];
  }

  set currentDeliverySlot(deliverySlot) {
    this.slotIndex = this.deliverySlots.indexOf(deliverySlot);
  }

  public nextSlot() {
    if (this.deliverySlots.length - 1 > this.slotIndex) {
      this.slotIndex++;
    }
  }

  public previousSlot() {
    if (this.slotIndex > 0) {
      this.slotIndex--;
    }
  }
}
